import { forwardRef } from 'react';
import cn from 'classnames';

import { defineTheme } from 'js/utils/theme-helpers';

import HtmlString from 'components/html-string/HtmlString';
import IconWarning from 'components/icon-warning/IconWarning';

import { IconWarning_Theme, IMessage } from 'source/NFR.types';

const messageThemes = defineTheme({
  red: 'message--theme-red',
  blue: 'message--theme-blue',
  gray: 'message--theme-gray'
});

const messageThemeMap: Record<number, string> = {
  [IconWarning_Theme.None]: '',
  [IconWarning_Theme.Red]: messageThemes('red') ?? '',
  [IconWarning_Theme.Blue]: messageThemes('blue') ?? '',
  [IconWarning_Theme.Gray]: messageThemes('gray') ?? ''
};

export interface MessageProps extends IMessage {
  className?: string;
  disableHTMLStringTabbing?: boolean;
  isTranslationLabel?: boolean;
}

const Message = forwardRef<HTMLDivElement, MessageProps>(
  ({ text, theme, className, disableHTMLStringTabbing, isTranslationLabel }, ref) => (
    <div
      className={cn('message', theme ? messageThemeMap[theme] : '', className, {
        'message--translation-label': isTranslationLabel
      })}
    >
      <div className="message--content">
        <div
          className={cn({
            'message--icon--hide': theme === IconWarning_Theme.Gray
          })}
        >
          <IconWarning theme={theme} size={isTranslationLabel ? 'small' : 'wide'} />
        </div>
        <div className={isTranslationLabel ? cn('message--small-text') : cn('message--text')} ref={ref}>
          <HtmlString {...text} disableTabbing={disableHTMLStringTabbing} />
        </div>
      </div>
    </div>
  )
);
Message.displayName = 'Message';

export default Message;
